import React, { useState } from 'react';
import { IconButton, Tooltip, useClipboard } from '@chakra-ui/react';
import { Copy, Check } from 'lucide-react';
import { useLanguage } from '../../../hooks/utility/useLanguage';

interface CopyButtonProps {
  textToCopy: string;
  size?: string;
  variant?: string;
  position?: 'absolute' | 'relative';
  top?: string | number;
  right?: string | number;
  bottom?: string | number;
  left?: string | number;
  color?: string;
  ariaLabel?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  size = 'sm',
  variant = 'ghost',
  position = 'relative',
  top,
  right,
  bottom,
  left,
  color = 'gray.500',
  ariaLabel,
}) => {
  const { onCopy, hasCopied } = useClipboard(textToCopy);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  return (
    <Tooltip
      label={hasCopied ? t('common.copied') : t('common.copyToClipboard')}
      placement="top"
      hasArrow
      isOpen={isVisible || hasCopied}
    >
      <IconButton
        icon={hasCopied ? <Check size={16} /> : <Copy size={16} />}
        size={size}
        variant={variant}
        aria-label={ariaLabel || t('common.copyToClipboard')}
        onClick={onCopy}
        position={position}
        top={top}
        right={right}
        bottom={bottom}
        left={left}
        color={hasCopied ? 'green.500' : color}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        opacity={isVisible || hasCopied ? 1 : 0.7}
        transition="all 0.2s"
      />
    </Tooltip>
  );
};

export default CopyButton;
